import { Alert, Button, Form, message } from "antd";
import { passwordValidation } from "src/utils/custom.validator";
import PasswordFormInputControl from "./passwordInput";
import { useCallback, useState } from "react";
import apiCalls from "src/api/apiCalls";
import { isErrorMessage } from "src/components/shared/error.message";
const ChangePassword = () => {
    const [errorMessage, setErrorMessage] = useState(null)
    const [form] = Form.useForm();
    const [buttonLoader, setButtonLoader] = useState(false)
    const onFinish = useCallback(async (values) => {
        setButtonLoader(true);
        try {

            if (values.newPassword !== values?.confirmNewPassword) {
                setErrorMessage("The New Password and Confirm New Password must be the same.");
                window.scroll(0, 0);
                return;
            }
            if (values.currentPassword === values?.newPassword || values.currentPassword === values?.confirmNewPassword) {
                setErrorMessage("The new password cannot be the same as the current password.");
                window.scroll(0, 0);
                return;
            }
            let obj = {
                currentPassword: values?.currentPassword,
                newPassword: values?.newPassword,
                repeatNewPassword: values?.confirmNewPassword,
            };
            const response = await apiCalls.changePassword(obj);
            if (response.ok) {
                form.resetFields();
                setErrorMessage(null)
                message.success({
                    content: "Password changed Successfully.",
                    className: "custom-msg",
                    duration: 3,
                })
            } else {
                setErrorMessage(isErrorMessage(response?.data));
                window.scroll(0, 0);
            }
        } catch (error) {
            setErrorMessage(error);
        } finally {
            setButtonLoader(false);
        }
    }, [form]);
    const closeError = useCallback(() => {
        setErrorMessage(null)
    }, [])
    return (
        <div className="">
            {errorMessage &&
                <div className='mb-4'>
                    <Alert
                        className='mb-6'
                        type="error"
                        description={errorMessage}
                        onClose={closeError}
                        showIcon
                        closable
                    />
                </div>
            }
            <Form layout="vertical" onFinish={onFinish} form={form}>
                <div className="grid grid-cols-1 md:grid-cols-2">
                    <div className="space-y-2">
                        <Form.Item
                            name="currentPassword"
                            className="custom-input input-label floatinput-label !text-whiteText relative currentPassword-input"
                            rules={[{ required: true, message: "Is required"},{ validator: passwordValidation }]}
                            label="Current Password"
                        >
                            <PasswordFormInputControl
                                name="currentPassword"
                                title="Current Password"
                                placeholder="Enter Current Password"
                                isRequired={false}
                                length={100}
                            />
                        </Form.Item>

                        <Form.Item
                            name="newPassword"
                            className="custom-input input-label floatinput-label !text-whiteText relative newPassword-input"
                            rules={[{ required: true, message: "Is required"},{ validator: passwordValidation }]}
                            label="New Password"
                        >
                            <PasswordFormInputControl
                                name="newPassword"
                                title="New Password"
                                placeholder="Enter New Password"
                                isRequired={false}
                                length={100}
                            />
                        </Form.Item>

                        <Form.Item
                            name="confirmNewPassword"
                            className="custom-input input-label floatinput-label !text-whiteText relative confirm-input"
                            rules={[{ required: true, message: "Is required"},{ validator: passwordValidation }]}
                            label="Confirm New Password"
                        >
                            <PasswordFormInputControl
                                name="confirmNewPassword"
                                title="Confirm New Password"
                                placeholder="Enter Confirm New Password"
                                isRequired={false}
                                length={100}
                                starRequired={true}
                            />
                        </Form.Item>
                    </div>
                </div>
                <Form.Item>
                    <div className='mt-2 md:flex justify-end gap-2 space-y-2 md:space-y-0'>
                        <Button className='primary-btn' type="primary" htmlType="submit" loading={buttonLoader}>Save</Button>
                    </div>
                </Form.Item>
            </Form>
        </div>
    );
};
export default ChangePassword;
